export default class MentionFormat {
  makeMentionables() {
    return this.instances ?? (this.instances = this.mentionables.map(Mentionable => new Mentionable(this)));
  }
  getMentionable(type) {
    return this.makeMentionables().find(mentionable => mentionable.type() === type) ?? null;
  }
  extend(mentionable) {
    if (!this.extendable) throw new Error('This mention format does not allow extending.');
    this.mentionables.push(mentionable);
  }

  /**
   * Picks the term to search in the API from the typed text.
   * @example:
   *  * Full text = `Hello @"John D`
   *  * Typed text = `"John D`
   *  * Query = `John D`
   */
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/formats/MentionFormat', MentionFormat);